import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("chizy_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const device_token = localStorage.getItem("chizy_device_token") || undefined;
      const { data } = await api.post("/auth/login", { email, password, device_token });
      if (data.requires_2fa) return data; // no guardamos sesión todavía
      applyAuth(data);
      return data;
    } finally {
      setLoading(false);
    }
  };

  const applyAuth = (data) => {
    localStorage.setItem("chizy_token", data.token);
    localStorage.setItem("chizy_user", JSON.stringify(data.user));
    if (data.device_token) {
      localStorage.setItem("chizy_device_token", data.device_token);
    }
    setUser(data.user);
  };

  const verify2fa = async (challengeToken, code) => {
    const { data } = await api.post("/auth/verify-2fa", { challenge_token: challengeToken, code });
    applyAuth(data);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("chizy_token");
    localStorage.removeItem("chizy_user");
    setUser(null);
    window.location.href = "/login";
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      const merged = { ...(user || {}), ...data };
      localStorage.setItem("chizy_user", JSON.stringify(merged));
      setUser(merged);
      return merged;
    } catch {
      return user;
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, refreshUser, verify2fa }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

// Static fallback (legacy callers still importing this constant)
export const ROLE_LABELS = {
  corporate_admin: "Corporativo",
  branch_manager: "Sucursal",
  treasury: "Finanzas",
  supplier: "Proveedor",
  legal: "Legal",
  operativo: "Operativo",
};

export function useRoleLabel() {
  const { t } = useTranslation();
  return (role) => t(`roles.${role}`, { defaultValue: role });
}
